export class ReportFilter {
    constructor(
        public requestedBy: string | null,
        public reference: string | null,
        public reportType: string | null,
    ){}
}